import React from "react";
import styled from "styled-components";

function StatInfo(props: any) {
  const { number, description } = props;
  return (
    <Wrapper className="data-chart">
      <div className={"stat-number"}>{number}</div>
      <div className={"stat-description"}>{description}</div>
    </Wrapper>
  );
}

export default StatInfo;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  max-width: 158px;
  width: 158px;
  .stat-number {
    font-weight: 500;
    font-size: 14px;
    color: #424b50;
    font-family: "Roboto Slab";
    line-height: 27px;
    letter-spacing: 0.7px;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      font-size: 13px;
      line-height: 8px;
    }
  }
  .stat-description {
    font-family: "Roboto";
    font-weight: 500;
    font-size: 12px;
    letter-spacing: 0.4px;
    line-height: 20px;
    color: #7e7e7e;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      font-size: 12px;
    }
  }
`;
